import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  NumberField,
  EditButton,
  DeleteButton,
  TopToolbar,
  CreateButton,
  ExportButton,
  FilterButton,
  SearchInput,
  BooleanInput,
  ReferenceInput,
  SelectInput,
  Filter,
  ReferenceField,
  FunctionField,
} from 'react-admin';

const CaseFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
    <ReferenceInput source="categoryId" reference="case-categories">
      <SelectInput optionText="name" />
    </ReferenceInput>
    <BooleanInput source="isActive" />
  </Filter>
);

const CaseListActions = () => (
  <TopToolbar>
    <FilterButton />
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

export const CaseList = () => (
  <List
    filters={<CaseFilter />}
    actions={<CaseListActions />}
    sort={{ field: 'sortOrder', order: 'ASC' }}
    perPage={25}
  >
    <Datagrid rowClick="show">
      <TextField source="title" />
      <FunctionField 
        label="Cover Image" 
        render={(record: any) => 
          record.coverImage?.url ? (
            <img 
              src={record.coverImage.url} 
              alt="Cover" 
              style={{ width: 50, height: 50, objectFit: 'cover' }} 
            />
          ) : (
            <span>No image</span>
          )
        } 
      />
      <TextField source="from" />
      <TextField source="to" />
      <TextField source="machine" />
      <NumberField source="time" label="Время (дни)" />
      <TextField source="logisticPrice" />
      <ReferenceField source="categoryId" reference="case-categories">
        <TextField source="name" />
      </ReferenceField>
      <BooleanField source="isActive" />
      <NumberField source="sortOrder" />
      <EditButton />
      <DeleteButton mutationMode="pessimistic" />
    </Datagrid>
  </List>
);
